import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { TranslationBoardRow } from '../../../models/translations/translation-board-row.model';

@Injectable()
export class TranslationsService {
  private readonly url: string = environment.api.API_ENDPOINT;

  public constructor(private httpClient: HttpClient) {}

  public autoTranslate(
    baseTexts: { [key: string]: string },
    targetLanguages: string[],
  ): Observable<{ [key: string]: { [lang: string]: string } }> {
    return this.httpClient.post<{ [key: string]: { [lang: string]: string } }>(
      `${this.url}/translations/ai`, { baseTexts, targetLanguages });
  }

  public getBoard(businessUnit?: string, preferencePageId?: string): Observable<TranslationBoardRow[]> {
    let params: HttpParams = new HttpParams();
    if (businessUnit) { params = params.set('businessUnit', businessUnit); }
    if (preferencePageId) { params = params.set('preferencePageId', preferencePageId); }
    return this.httpClient.get<TranslationBoardRow[]>(`${this.url}/translations/board`, { params });
  }

  public saveBoard(rows: TranslationBoardRow[]): Observable<void> {
    return this.httpClient.put<void>(`${this.url}/translations/board`, rows);
  }
}
